/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationMetricSeries {
    getFixupPrototypeFunction() { return UtilizationMetricSeries.fixupPrototype; }

    static newInstance(model: Partial<UtilizationMetricSeries>): UtilizationMetricSeries {
        let obj = Object.assign(new UtilizationMetricSeries(), model);
        UtilizationMetricSeries.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationMetricSeries>): UtilizationMetricSeries {
        if (!model) return null;
        return UtilizationMetricSeries.newInstance(<UtilizationMetricSeries> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationMetricSeries) {
        if (!obj) return;

        models.UtilizationMetricSeries.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationMetricSeries): boolean {
        Object.setPrototypeOf(obj, UtilizationMetricSeries.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of maximum utilization metrics.
     */
    maximum: Array<number>;

    /**
     * List of minimum utilization metrics.
     */
    minimum: Array<number>;

    /**
     * List of average utilization metrics.
     */
    average: Array<number>;

    /**
     * List of total (sum) utilization values.
     */
    sum: Array<number>;

    /**
     * The count (number) of data points used for the statistical calculation.
     */
    count: Array<number>;

}
